import React from "react";
import * as moment from "moment-timezone";
import { calcularTiempoTrabajado } from "../../interfaces/formik/IReporteRelojChecador.ts";
import { formatPayrollHoursDecimal } from "../../services/payroll/ui.ts";

interface ReporteRow {
  checkIn: string | undefined;
  checkOut: string | null | undefined;
  día: string;
}

const TableChecks = ({ records }: { records: ReporteRow[] }) => {
  return (
    <div className="table-sticky mb-3 shadow-sm">
      <table className="table table-hover table-panel text-nowrap align-middle mb-0 bg-white">
        <thead className="sticky-thead table-light text-center">
          <tr>
            <th className="align-middle"></th>
            <th className="align-middle">Fecha</th>
            <th className="align-middle">Entrada</th>
            <th className="align-middle">Salida</th>
            <th className="align-middle">Horas trabajadas</th>
            <th className="align-middle">Horas extras</th>
          </tr>
        </thead>
        <tbody className="accordion" id="accordionExample">
          {records.map((record, index) => (
            <React.Fragment>
              <RowReporteChequeo record={record} no={index + 1} key={index} />
              {/* <RowHourSum index={index} records={reportData} /> */}
            </React.Fragment>
          ))}

          <LastRowSummary records={records} />
        </tbody>
      </table>
    </div>
  );
};

export default TableChecks;

const RowReporteChequeo = ({
  record,
  no,
}: {
  record: ReporteRow;
  no: number;
}) => {
  return (
    <tr className="text-center">
      <td>{no}</td>
      <td>{record.día}</td>
      <td> {record?.checkIn} </td>
      <td> {record?.checkOut ?? ""} </td>
      <td>
        {formatPayrollHoursDecimal(
          calcularTiempoTrabajado(record?.checkIn!, record?.checkOut!)
        )}
      </td>
      <td>
        {formatPayrollHoursDecimal(
          Math.max(
            0,
            calcularTiempoTrabajado(record?.checkIn!, record?.checkOut!) - 8.5
          )
        )}
      </td>
    </tr>
  );
};

const LastRowSummary = ({ records }: { records: ReporteRow[] }) => {
  const [totalHours, setTotalHours] = React.useState(0);
  const [totalExtraHours, setTotalExtraHours] = React.useState(0);

  React.useEffect(() => {
    setTotalHours(
      records.reduce((acc, record) => {
        const time = Math.floor(
          calcularTiempoTrabajado(record.checkIn!, record.checkOut!)
        );
        return acc + Number(time) || 0;
      }, 0)
    );
  }, [records]);

  React.useEffect(() => {
    setTotalExtraHours(
      records.reduce((acc, record) => {
        const extraTime = Math.floor(
          Math.max(
            0,
            calcularTiempoTrabajado(record.checkIn!, record.checkOut!) - 8.5
          )
        );
        return acc + Number(extraTime) || 0;
      }, 0)
    );
  }, [records]);
  return (
    <React.Fragment>
      <tr className="text-center">
        <td colSpan={4} className="text-end">
          <strong>Horas totales</strong>
        </td>
        <td>{totalHours}</td>
        <td>{totalExtraHours}</td>
      </tr>
      <tr className="text-center" style={{backgroundColor: '#d4edda', color: 'white'}}>
        <td colSpan={4} className="text-end">
          <strong>Horas reales</strong>
        </td>
        <td>{totalHours - totalExtraHours}</td>
        <td>{totalExtraHours}</td>
      </tr>
    </React.Fragment>
  );
};
